module.exports = __webpack_public_path__ + "static/media/facebookPost.2170bb61.jpg";